import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Spectacular Eastern Bay Views Overlooking the Mumbai Skyline",
    "Seamlessly Connected Location from Eastern Express Highway",
    "Upcoming Sewri-Worli Elevated Corridor 5 Minutes Away",
  ];
  const highlights2 = [
    "5 Storey Clubhouse with Lifestyle Amenities",
    "A Social Life amidst Nature’s Serene Embrace",
    "Home to Great Education with Reputed Schools and Institutes",
  ];
  return (
    <section className="section shadow-sm lazyloaded" id="overview">
      <div className="over1">
        <h1 className="d-block section-heading color-primary text-capitalize">
          {/* {project} - Overview */}
          {/* Godrej Horizon Presents Pinnacle of Dadar-Wadala */}
          Godrej Horizon Presents Pinnacle of Dadar-Wadala
        </h1>

        <p>
          Welcome to Pinnacle of Dadar-Wadala, a landmark residential project of
          Godrej Horizon in Dadar-Wadala, Mumbai, where modern luxury meets
          timeless heritage. Designed for those who seek panoramic Eastern Bay
          views, seamless connectivity, and elevated living, this high-rise
          development offers spacious 2 & 3 BHK residences with world-class
          amenities.
          <br />
          Located just minutes from BKC, Eastern Express Highway, and the
          upcoming Metro, Godrej Horizon ensures that you stay connected to
          Mumbai's key business hubs while enjoying a serene and sophisticated
          lifestyle. Whether it's the iconic Five Gardens or the breathtaking
          Mumbai skyline, every detail here enhances your living experience.
          <br />
          <b>Step into the future of luxury living at Godrej Horizon!</b>
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy text-capitalize">
              <li>
                <span>Spacious 1 & 2 BHK Residences</span>
              </li>
              <li>
                <span>
                  Iconic high-rise 46-Storey Towers with premium architecture
                </span>
              </li>
              <li>
                <span>
                  Unmatched Investment Potential with high appreciation value
                </span>
              </li>
            </ul> */}

            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy">
              <li>
                <span>Smart layouts for modern families</span>
              </li>
              <li>
                <span>
                  Seamless Connectivity to EEH, Railway Station & Malls
                </span>
              </li>
              <li>
                <span>
                  Marvellous Amenities like Clubhouse, Swimming Pool & More
                </span>
              </li>
            </ul> */}
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
